import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

function coerceToDate(value: any): Date | null {
  if (value == null || value === '') {
    return null;
  }
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'number') {
    if (!isFinite(value)) {
      return null;
    }
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed || trimmed === '-' || trimmed === 'N/A' || trimmed === 'null' || trimmed === 'undefined') {
      return null;
    }
    let dateStr = trimmed;
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      dateStr = `${trimmed}T00:00:00`;
    }
    const date = /^\d+$/.test(dateStr) ? new Date(Number(dateStr)) : new Date(dateStr);
    return isNaN(date.getTime()) ? null : date;
  }
  return null;
}

function resolveLocale(userData: any, locale?: string): string | undefined {
  const candidate = userData?.languages?.locale ?? locale;
  if (typeof candidate !== 'string') {
    return undefined;
  }
  const normalized = candidate.trim();
  return normalized || undefined;
}

@Pipe({
    name: 'customDate',
    standalone: false
})
export class CustomDateFormatPipe extends DatePipe implements PipeTransform {
  override transform(value: any, format?: string | boolean, timezone?: string, locale?: string): any {
    const date = coerceToDate(value);
    if (!date) {
      return '';
    }

    const userData =
      localStorage.getItem('loginUserValue') &&
      JSON.parse(localStorage.getItem('loginUserValue'));

    let finalFormat: string;

    if (typeof format === 'string' && format) {
      finalFormat = format;
    } else {
      let showTime = true;
      if (typeof format === 'boolean') {
        showTime = format;
      }
      finalFormat = showTime ? 'EE d MMM, y, h:mm a' : 'EE d MMM, y';
    }

    try {
      return super.transform(date, finalFormat, timezone, resolveLocale(userData, locale));
    } catch {
      return '';
    }
  }
}
